export const Add = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			d="M8.91675 3.4445C8.91675 2.93824 8.50634 2.52783 8.00008 2.52783C7.49382 2.52783 7.08342 2.93824 7.08342 3.4445V7.1945H3.33341C2.82715 7.1945 2.41675 7.6049 2.41675 8.11117C2.41675 8.61743 2.82715 9.02783 3.33341 9.02783H7.08342V12.7778C7.08342 13.2841 7.49382 13.6945 8.00008 13.6945C8.50634 13.6945 8.91675 13.2841 8.91675 12.7778V9.02783H12.6667C13.173 9.02783 13.5834 8.61743 13.5834 8.11117C13.5834 7.6049 13.173 7.1945 12.6667 7.1945H8.91675V3.4445Z"
			fill="currentColor"
		/>
	</svg>
);
